/**
 * GZAnalytics
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function isDebugEnabled() {
    try {
      return (
        (window.ThemeConfig && window.ThemeConfig.isDesignMode) ||
        window.localStorage.getItem('gz_analytics_debug') === '1' ||
        /[?&]gtm_debug=1/.test(window.location.search)
      );
    } catch (e) {
      return false;
    }
  }

  function push(eventObject) {
    window.dataLayer.push(eventObject);
    if (isDebugEnabled()) {
      // eslint-disable-next-line no-console
      console.log('%c[GZAnalytics]', 'color:#0a7', eventObject);
    }
  }

  function pushEcommerce(eventName, ecommerceObject, extra) {
    push({ ecommerce: null });
    push(Object.assign({ event: eventName, ecommerce: ecommerceObject }, extra || {}));
  }

  function readData(el, key) {
    var value = el.dataset ? el.dataset[key] : undefined;
    return value === undefined || value === '' ? undefined : value;
  }

  function toNumber(value) {
    if (value === undefined || value === null || value === '') return undefined;
    var n = parseFloat(value);
    return isNaN(n) ? undefined : n;
  }

  function orNull(value) {
    return value === undefined ? null : value;
  }

  function buildItemObject(source, overrides) {
    var item = {
      item_name: orNull(source.item_name || source.product_title || source.title),
      item_id: orNull(source.item_id || source.product_id),
      item_variant_id: orNull(source.item_variant_id || source.sku),
      item_variant: orNull(source.item_variant || source.variant_title),
      item_color: orNull(source.item_color),
      currency: orNull(source.currency),
      price: orNull(toNumber(source.price !== undefined ? source.price : source.final_price)),
      quantity: toNumber(source.quantity) || 1,
      discount: orNull(toNumber(source.discount)),
      coupon: orNull(source.coupon),
      item_category: orNull(source.item_category),
      item_category2: orNull(source.item_category2),
      item_category3: orNull(source.item_category3),
      item_category4: orNull(source.item_category4),
      item_category5: orNull(source.item_category5),
      item_brand: orNull(source.item_brand || source.vendor),
      index: orNull(toNumber(source.index)),
      item_discounted: source.item_discounted === true || source.item_discounted === 'true',
      item_list_name: orNull(source.item_list_name),
      item_collection_id: source.item_collection_id
    };

    // /cart/add.js and /cart/change.js return price/final_price in cents.
    if (source.__pricesInCents && typeof item.price === 'number') {
      item.price = item.price / 100;
    }


    Object.keys(overrides || {}).forEach(function (key) {
      if (overrides[key] !== undefined) item[key] = overrides[key];
    });

    return englishCategories(item);
  }

  function readItemDataset(el) {
    return {
      item_name: readData(el, 'itemName'),
      item_id: readData(el, 'itemId'),
      item_variant_id: readData(el, 'itemVariantId'),
      item_variant: readData(el, 'itemVariant'),
      item_color: readData(el, 'itemColor'),
      currency: readData(el, 'currency'),
      price: readData(el, 'price'),
      quantity: readData(el, 'quantity'),
      discount: readData(el, 'discount'),
      coupon: readData(el, 'coupon'),
      item_category: readData(el, 'itemCategory1'),
      item_category2: readData(el, 'itemCategory2'),
      item_category3: readData(el, 'itemCategory3'),
      item_category4: readData(el, 'itemCategory4'),
      item_category5: readData(el, 'itemCategory5'),
      item_brand: readData(el, 'itemBrand'),
      index: readData(el, 'itemIndex'),
      item_discounted: readData(el, 'itemDiscounted') === 'true',
      item_list_name: readData(el, 'itemListName'),
      item_collection_id: readData(el, 'itemCollectionId')
    };
  }

  var FILTER_TYPE_MAP = {
    'filter.v.option.size': 'size',
    'filter.p.m.zanotti_product.color_hex': 'color',
    'filter.p.m.zanotti_product.model_filter': 'model',
    'filter.p.m.zanotti_product.heel_filter': 'heel',
    'filter.p.m.zanotti_product.occasion_use': 'occasion_use',
    'filter.p.m.zanotti_product.product_family': 'product_family'
  };

  function normalizeFilters(filters) {
    return filters.map(function (filter) {
      var pipeIndex = (filter.value || '').indexOf('|');
      return {
        type: FILTER_TYPE_MAP[filter.type] || filter.type,
        value: pipeIndex !== -1 ? filter.value.slice(pipeIndex + 1) : filter.value
      };
    });
  }

  function getFilterState() {
    var blob = document.getElementById('AnalyticsActiveFilters');
    if (blob) {
      try {
        var parsed = JSON.parse(blob.textContent);
        if (Array.isArray(parsed) && parsed.length) return normalizeFilters(parsed);
      } catch (e) {
        // fall through to query-string parsing
      }
    }

    var filters = [];
    var params = new URLSearchParams(window.location.search);
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) {
        filters.push({ type: key, value: value });
      }
    });
    return normalizeFilters(filters);
  }

  function pushViewItemListFromElements(elements, listName, options) {
    var rows = [];
    Array.prototype.forEach.call(elements, function (el) {
      if (!el.querySelectorAll) return;
      if (el.hasAttribute && el.hasAttribute('data-item-id')) {
        rows.push(el);
      } else {
        rows = rows.concat(Array.prototype.slice.call(el.querySelectorAll('[data-item-id]')));
      }
    });

    rows = rows.filter(function (row) {
      if (row.hasAttribute('data-analytics-listed')) return false;
      row.setAttribute('data-analytics-listed', 'true');
      return true;
    });
    if (!rows.length) return;

    options = options || {};
    var filters = options.filters || getFilterState();
    var chunkSize = 10;

    for (var start = 0; start < rows.length; start += chunkSize) {
      var chunkItems = rows.slice(start, start + chunkSize).map(function (row, i) {
        var dataset = readItemDataset(row);
        var index = dataset.index !== undefined ? toNumber(dataset.index) : start + i + 1;
        return buildItemObject(dataset, { item_list_name: dataset.item_list_name || listName, index: index });
      });

      pushEcommerce(
        'view_item_list',
        { items: chunkItems },
        { filters: filters, search: options.searchTerm || null }
      );
    }
  }

  function pushViewItemListFromContainer(containerSelector, listName, options) {
    var container = document.querySelector(containerSelector);
    if (container) pushViewItemListFromElements([container], listName, options);
  }

  // Guards single-fire-per-page events (view_item, page-load view_cart, searchbar)
  // against the same section script running twice, e.g. a Theme Editor sync reload.
  var firedOnce = {};
  function pushOnce(key, fn) {
    if (firedOnce[key]) return;
    firedOnce[key] = true;
    fn();
  }

  function getCurrentSearchTerm() {
    var predictiveInput = document.querySelector('[data-predictive-search-input]');
    if (predictiveInput && predictiveInput.value) return predictiveInput.value;
    var params = new URLSearchParams(window.location.search);
    return params.get('q') || null;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (!link) return;

    // Product cards only: cart lines carry data-item-id too, but their links (product, Remove)
    // aren't picked from a list
    var card = link.closest('[data-item-id][data-item-list-name]');
    if (!card) return;

    var item = buildItemObject(readItemDataset(card));
    pushEcommerce(
      'select_item',
      { items: [item] },
      { filters: getFilterState(), search: getCurrentSearchTerm() }
    );
  });

  // menu_interaction and item_category* report the English names in every language. Liquid only
  // renders the current one, so outside the primary locale the header and the collection titles
  // are fetched once per session from the root (primary language) and matched by key.
  var englishLabels = null;
  var labelsHeader = document.getElementById('gz-header');
  var labelsSectionId =
    labelsHeader && labelsHeader.getAttribute('data-locale-primary') !== 'true'
      ? labelsHeader.getAttribute('data-section-id')
      : null;
  var labelsCacheKey = 'gz_labels_en:' + labelsSectionId;

  // Read right away, so the events fired on page load already use the cached labels
  if (labelsSectionId) {
    try {
      englishLabels = JSON.parse(window.sessionStorage.getItem(labelsCacheKey));
    } catch (e) {}
  }

  // Same split as product-item-categories.liquid
  function categoryLevels(title) {
    return (title.indexOf('>') !== -1 ? title.split('>') : title.split('||')).map(function (level) {
      return level.trim();
    });
  }

  function loadEnglishLabels() {
    fetch('/?sections=' + encodeURIComponent(labelsSectionId) + ',analytics-collection-titles', { priority: 'low' })
      .then(function (response) {
        return response.ok ? response.json() : Promise.reject(response.status);
      })
      .then(function (sections) {
        var labels = { menu: {}, collections: {} };
        var parser = new DOMParser();
        var headerDoc = parser.parseFromString(sections[labelsSectionId] || '', 'text/html');
        headerDoc.querySelectorAll('[data-menu-key]').forEach(function (el) {
          labels.menu[el.getAttribute('data-menu-key')] = [
            el.getAttribute('data-menu-level1') || el.getAttribute('data-mobile-title'),
            el.getAttribute('data-menu-level2'),
            el.getAttribute('data-menu-level3')
          ];
        });
        var titlesDoc = parser.parseFromString(sections['analytics-collection-titles'] || '', 'text/html');
        var titles = titlesDoc.getElementById('AnalyticsCollectionTitles');
        if (titles) {
          var titlesById = JSON.parse(titles.textContent);
          Object.keys(titlesById).forEach(function (id) {
            labels.collections[id] = categoryLevels(titlesById[id]);
          });
        }
        englishLabels = labels;
        try {
          window.sessionStorage.setItem(labelsCacheKey, JSON.stringify(labels));
        } catch (e) {}
      })
      .catch(function () {});
  }

  // Off the critical path: after load, when the browser is idle (within 3s at the latest)
  function scheduleEnglishLabels() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(loadEnglishLabels, { timeout: 3000 });
    } else {
      setTimeout(loadEnglishLabels, 2000);
    }
  }
  if (labelsSectionId && !englishLabels) {
    if (document.readyState === 'complete') {
      scheduleEnglishLabels();
    } else {
      window.addEventListener('load', scheduleEnglishLabels);
    }
  }

  // English category levels of a collection, null until they are loaded (or in the primary locale)
  function englishCategoryLevels(collectionId) {
    return (collectionId && englishLabels && englishLabels.collections[collectionId]) || null;
  }

  // Swaps item_category..5 for the English levels of item.item_collection_id, which is dropped
  function englishCategories(item) {
    var levels = englishCategoryLevels(item.item_collection_id);
    delete item.item_collection_id;
    if (levels) {
      ['item_category', 'item_category2', 'item_category3', 'item_category4', 'item_category5'].forEach(function (key, i) {
        item[key] = levels[i] || null;
      });
    }
    return item;
  }

  // English labels for a menu entry, the rendered (translated) ones until they are loaded
  function menuLabels(el) {
    var english = englishLabels && englishLabels.menu[el.getAttribute('data-menu-key')];
    var labels = english || [
      el.getAttribute('data-menu-level1') || el.getAttribute('data-mobile-title'),
      el.getAttribute('data-menu-level2'),
      el.getAttribute('data-menu-level3')
    ];
    return {
      menu_first_level: labels[0] || undefined,
      menu_second_level: labels[1] || undefined,
      menu_third_level: labels[2] || undefined
    };
  }

  // Links only: submenu and accordion buttons are tracked in global.js, behind the
  // menu_interaction_all_levels setting. Without it, a link that goes nowhere is skipped too.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-menu-level1]');
    if (!link) return;
    var allLevels = window.ThemeConfig && window.ThemeConfig.menuInteractionAllLevels;
    if (!allLevels && link.getAttribute('href') === '#') return;

    push(Object.assign({ event: 'menu_interaction' }, menuLabels(link)));
  });

  window.GZAnalytics = {
    push: push,
    pushEcommerce: pushEcommerce,
    pushOnce: pushOnce,
    buildItemObject: buildItemObject,
    readItemDataset: readItemDataset,
    pushViewItemListFromContainer: pushViewItemListFromContainer,
    pushViewItemListFromElements: pushViewItemListFromElements,
    menuLabels: menuLabels,
    englishCategories: englishCategories,
    englishCategoryLevels: englishCategoryLevels
  };

  var queued = window.GZAnalyticsQueue || [];
  queued.forEach(function (fn) {
    fn(window.GZAnalytics);
  });
  window.GZAnalyticsQueue = {
    push: function (fn) {
      fn(window.GZAnalytics);
    }
  };
})();
